export default __webpack_public_path__ + "static/media/PaintingTheLoft_04.0c863a30.png";